import React, { useEffect, useState } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ECharts, { EChartsReactProps } from 'echarts-for-react';
const moment=require('moment-jalaali');
let dates=[];
let newArr=[]
for(let i=1;i<31;i++){
  let date=moment().subtract(i,'days').format('jYY/jM/jD')
  const arr=dates.unshift(date);
  
 
}
const d=<CalendarMonthIcon/>;


for(let o=0;o<1;o++){
  const hours=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]
  for(let j=0;j<hours.length;j++){
    newArr.push(`${dates[o]} \n ${hours[j]}:00 `)

  }
}



const StChart2 = ({stats,flag}) => {
  const colors = ['#5470C6', '#91CC75', '#EE6666','orange','purple'];
  const [walk,setWalk]=useState([])
  const [temp,setTemp]=useState([])
const [ch,setCh]=useState([]);
const [re,setRe]=useState([]);
const [sl,setSl]=useState([])
const [ti,setTi]=useState([])
const [timeformat,setTimeFormat]=useState([])
useEffect(()=>{
if(stats){
  const che=stats&&stats.map(item=>{
    const {unrest}=item;
    
    return unrest
  })
  setCh(che)
  
  const sle= stats&&stats.map(item=>{
    const {activity}=item;
   
    return activity
  })
  setSl(sle)
  const tmp= stats&&stats.map(item=>{
    const {temperature}=item;
   
    return temperature
  })
  setTemp(tmp)
  const wlk= stats&&stats.map(item=>{
    const {walking}=item;
   
    return walking
  })
  setWalk(wlk)
  const tim= stats&&stats.map(item=>{
    const {intervalTime}=item;
   const day=moment(intervalTime).format(`jDD`)
   const time=moment(intervalTime).format(`HH`)
    return `${day}\n${time}`
  })
  setTi(tim)
  const timf= stats&&stats.map(item=>{
    const {intervalTime}=item;
   const day=moment(intervalTime).format(`jMM/jDD`)
   const time=moment(intervalTime).format(`HH:00`)
    return `${day}\n${time} `
  })
  setTimeFormat(timf)
}
},[stats])



  useEffect(()=>{
    setOptions({
      
      
      color: colors,
      // tooltip: {
      //   trigger: 'axis',
      //   valueFormatter: (timeformat) => '$' + value.toFixed(2)
        
      // },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
        
      },
      grid: {
        
      },
     
      legend: {
        align:'right',
        data: ['    میزان فعالیت : ', '    میزان  استرس : ']
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          
          // prettier-ignore
          data: timeformat
        },
      
      ],
      dataZoom: [
        {
          type: 'slider',
          show: true,
          
          start: flag==0?0:85,
          end: 100
        },
        {
          start: 80,
          type: "inside"
        },
      ],
        
      yAxis: [
        
        {
          type: 'value',
          name: '',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: colors[2]
            }
          },
          axisLabel: {
            formatter: '{value} '
          }
        }
      ],
     
      series: [
        {
          name: '    میزان فعالیت : ',
          type: 'line',
          yAxisIndex: 0,

          data: sl
        },
        {
          name: '    میزان  استرس : ',
          type: 'line',
          yAxisIndex: 0,
          
          data: ch
        },
        
      ],
      
    })
  },[ch,re,sl,walk,temp])


  const [options, setOptions] = useState({
    dataZoom: [
      {
        type: 'inside',
        throttle: 50
      }
    ],
    color: colors,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      }
    },
    grid: {
      
    },
   
    legend: {
      align:'right',
      data: ['    میزان فعالیت : ', '    میزان  استرس : ']
    },
    xAxis: [
      {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        // prettier-ignore
        data: newArr
      },
    
    ],
    dataZoom: [
      {
        type: 'slider',
        show: true,
        
        start: 85,
        end: 100
      }],
    yAxis: [
      
      {
        type: 'value',
        name: 'دقیقه',
        position: 'left',
        alignTicks: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: colors[2]
          }
        },
        axisLabel: {
          formatter: '{value} دقیقه'
        }
      },
      
    ],
    series: [
        {
          name: '    میزان فعالیت : ',
          type: 'line',
          yAxisIndex: 0,

          data: sl
        },
        {
          name: '    میزان  استرس : ',
          type: 'line',
          yAxisIndex: 0,
          
          data: ch
        },
        
      ],
	});	

	return (
    <ECharts
    
			option={options}
      opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
    />
  );
}
export default StChart2